import { companyConstants, fileConstants,alertConstants} from '../_constants'
import { companyService } from '../_services'
import { alertActions} from './'

export const companyActions = {
  addCompany,
  getCompany,
  logoUpload,
  getCompanyById,
  getCompanyByPage,
  bulkAdd,
  bulkUpdate,
  bulkUpdatesubBrand,
  deleteCompany,
  activeCompany,
  clearAllMessages,
  getFileUploadLogs,
  deleteFileLogById,
  bulkAddForCopyPaste,
  clearFileLog,
  updateSubBrand
}
function clearFileLog() {
  return dispatch => {
    dispatch(success())
  }
  function success() { return { type: companyConstants.MESSAGE_CLEAR } }
}
function updateSubBrand(data) {
  return dispatch => {
    dispatch(success(data))
  }
  function success(data) { return { type: companyConstants.UPDATE_SUB_BRAND,data } }
}
function deleteCompany(id,userId) {
  return dispatch => {
    dispatch(request(id,userId))
    companyService.deleteCompany(id,userId)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: companyConstants.DELETE_REQUEST, response } }
  function success(response) { return { type: companyConstants.DELETE_SUCCESS, response } }
  function failure(error) { return { type: companyConstants.DELETE_FAILURE, error } }
}

function activeCompany(id, isActive) {
  return dispatch => {
    dispatch(request(id))
    companyService.activeCompany(id, isActive)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: companyConstants.ACTIVE_REQUEST, response } }
  function success(response) { return { type: companyConstants.ACTIVE_SUCCESS, response } }
  function failure(error) { return { type: companyConstants.ACTIVE_FAILURE, error } }
}

function addCompany(company) {
  return dispatch => {
    dispatch(request(company))
    companyService.addCompany(company)
      .then(
        company => {
          console.log(company)
          dispatch(success(company))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.ADD_REQUEST, company } }
  function success(company) { return { type: companyConstants.ADD_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.ADD_FAILURE, error } }
}

function getCompany() {
  return dispatch => {
    dispatch(request())
    companyService.getCompany()
      .then(
        company => {
          console.log('company' + company)
          if (company.data)
            dispatch(success(company))
          else
            dispatch(failure('error'))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.GETALL_REQUEST, company } }
  function success(company) { return { type: companyConstants.GETALL_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.GETALL_FAILURE, error } }
}
function getCompanyById(id) {
  return dispatch => {
    dispatch(request())

    companyService.getCompanyById(id)
      .then(
        company => {
          console.log(company)
          dispatch(success(company))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(result) { return { type: companyConstants.GETBYID_REQUEST, result } }
  function success(result) { return { type: companyConstants.GETBYID_SUCCESS, result } }
  function failure(error) { return { type: companyConstants.GETBYID_FAILURE, error } }
}


function logoUpload(file) {
  return dispatch => {
    dispatch(request(file))
    companyService.logoUpload(file)
      .then(
        result => {
          console.log(result.data)
          if (result.data)
            dispatch(success(result.data))
          else {
            dispatch(failure('error'))
          }
        }, error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(result) { return { type: fileConstants.UPLOAD_REQUEST, result } }
  function success(result) { return { type: fileConstants.UPLOAD_SUCCESS, result } }
  function failure(error) { return { type: fileConstants.UPLOAD_FAILURE, error } }
}

function getCompanyByPage(start,pageSize,search,type,typeId,sortBy) {
  return dispatch => {
    dispatch(request({start,pageSize, search,type,typeId,sortBy}))
    companyService.getCompanyByPage(start,pageSize, search,type,typeId,sortBy)
      .then(
        company => {
          console.log('company' + company)
          if (company.data) {
            dispatch(success(company))
            dispatch(alertActions.clear())
          } else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.GETALL_PAGE_REQUEST, company } }
  function success(company) { return { type: companyConstants.GETALL_PAGE_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.GETALL_PAGE_FAILURE, error } }
}

function bulkAdd(companyList) {
  return dispatch => {
    dispatch(request())
    companyService.bulkAdd(companyList)
      .then(
        company => {
          console.log('company' + company)
          if (company.data)
            dispatch(success(company.data))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.BULK_ADD_REQUEST, company } }
  function success(company) { return { type: companyConstants.BULK_ADD_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.BULK_ADD_FAILURE, error } }
}


function bulkUpdate(companyList) {
  return dispatch => {
    dispatch(request())
    companyService.bulkUpdate(companyList)
      .then(
        company => {
          console.log('company' + company)
          if(company.data){
            dispatch(success(company))
          }
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.BULK_UPDATE_REQUEST, company } }
  function success(company) { return { type: companyConstants.BULK_UPDATE_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.BULK_UPDATE_FAILURE, error } }
}

function bulkUpdatesubBrand(companyList) {
  return dispatch => {
    dispatch(request())
    companyService.bulkUpdatesubBrand(companyList)
      .then(
        company => {
          console.log('company' + company)
          if(company.data){
            dispatch(success(company))
            dispatch(getCompanyByPage(0,20,'',null,null,''))
          }
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.BULK_UPDATE_REQUEST, company } }
  function success(company) { return { type: companyConstants.BULK_UPDATE_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.BULK_UPDATE_FAILURE, error } }
}

function clearAllMessages()
{
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}

function getFileUploadLogs(start=0,pageSize=5) {
  return dispatch => {
    dispatch(request())
    companyService.getFileUploadLogs(start,pageSize)
      .then(
        response => {
          console.log('company' + response)
          if (response.data)
            dispatch(success(response))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: companyConstants.BULK_FILE_UPLOAD_LOG_REQUEST, response } }
  function success(response) { return { type: companyConstants.BULK_FILE_UPLOAD_LOG_SUCCESS, response } }
  function failure(error) { return { type: companyConstants.BULK_FILE_UPLOAD_LOG_FAILURE, error } }
}
function deleteFileLogById(id) {
  return dispatch => {
    dispatch(request())
    companyService.deleteFileLogById(id)
      .then(
        response => {
          console.log('company' + response.message)
          if (response.message)
            dispatch(success(response.message))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: companyConstants.BULK_FILE_UPLOAD_DELETE_REQUEST, response } }
  function success(response) { return { type: companyConstants.BULK_FILE_UPLOAD_DELETE_SUCCESS, response } }
  function failure(error) { return { type: companyConstants.BULK_FILE_UPLOAD_DELETE_FAILURE, error } }
}

function bulkAddForCopyPaste(companyList, id) {
  return dispatch => {
    dispatch(request())
    companyService.bulkAddForCopyPaste(companyList, id)
      .then(
        company => {
          console.log('company' + company)
          if (company.data)
            dispatch(success(company.data))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(company) { return { type: companyConstants.BULK_ADD_REQUEST, company } }
  function success(company) { return { type: companyConstants.BULK_ADD_SUCCESS, company } }
  function failure(error) { return { type: companyConstants.BULK_ADD_FAILURE, error } }
}
